import Cookies from 'universal-cookie';

const getTimezoneLabel = () => {
  const cookies = new Cookies();

  const timezone = cookies.get('organization')?.timezone;
  const isWIB = timezone === 'Asia/Jakarta';
  const timezoneLabel = isWIB ? 'WIB' : 'MYT';

  return timezoneLabel;
};

export default getTimezoneLabel;
